export const capitalize = (text) => text && text.charAt(0).toUpperCase() + text.slice(1);